export default class extends Controller {

  submit(event) {
    event.preventDefault();
    App.Helpers.ajaxRequest({
      url:            this.submitURL,
      method:         "POST",
      data:           App.Helpers.formDataAsString(this.form),
      successHandler: this.redirect.bind(this),
      errorHandler:   this.renderResponse.bind(this)
    });
  }

  redirect({ id }) {
    document.location = this.redirectURLWithPlaceholder.replace(/PLACEHOLDER/g, id);
  }

  renderResponse({ responseText }) {
    App.Helpers.replaceElement(this.element, responseText, true);
  }

  //
  // GETTERS AND SETTERS
  //

  get form() {
    return this.element.closest("form");
  }

  get submitURL() {
    return this.form.action;
  }

  get redirectURLWithPlaceholder() {
    return this.data.get("redirect-url");
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/assets/javascript/forms-save-and-continue-controller.js